module.exports = __webpack_public_path__ + "static/media/5.c0baac69.jpg";